import { DailyPvUpdateParametersRequest } from '@doda/api-client/aspida/@types';
import { apiClient } from '@doda/api-client/util/apiClient';

/**
 * PVカウントアップ処理
 * @param {DailyPvUpdateParametersRequest} data
 * @param jid
 */
export const postPvCountUp = (
  data: DailyPvUpdateParametersRequest,
  jid: string
) => {
  return apiClient.api.v1.job._jid(jid).pvCountUp.$post({
    body: data,
  });
};
